import { v4 as uuidv4 } from 'uuid';

export function generateEndAt() {
    const date = new Date();

    const endDate = new Date(date.toISOString().slice(0, 10) + 'T23:59:59.000Z');
    
    const distance = 7 - new Date(date.toISOString().slice(0, 10) + 'T00:00:00.000Z').getDay();
    
    endDate.setDate(endDate.getDate() + distance);
    
    return endDate;
}

export function getDefaultHire() {
    const uniqueId = uuidv4();  

    return {
        key: uniqueId,
        uniqueId,
        can: generateEndAt(),
        lay: new Date(),
        hire: undefined,
        hireType: undefined,
        delivery: {},
        redelivery: {},
        mainRegionDelivery: {},
        mainRegionRedelivery: {},
        vessel: undefined,
    };
}

export function getDefaultError(r, { isNew = false } = {}) {
    const value = !!isNew;
    return {
        _id: r._id || r.uniqueId,
        hire: value,
        hireType: value,
        mainRegionDelivery: value,
        mainRegionRedelivery: value,
        vesselDwtGroup: value,
    };
}

// 1 - add to export select
// -1 - remore from export select
export const EXPORT_MAP = {
    vessel: { value: 1, label: 'Vessel' },
    lay: { value: 1, label: 'Lay' },
    can: { value: 1, label: 'Can' },
    hire: { value: 1, label: 'Hire' },
    hireType: { value: 1, label: 'Hire type' },
    // delivery: 1,
    // redelivery: 1,
    mainRegionDelivery: { value: 1, label: 'Main region delivery' },
    mainRegionRedelivery: { value: 1, label: 'Main region redelivery' },
    fuelPrice: { value: 1, label: 'Fuel price' },
    duration: { value: 1, label: 'Duration' },
    cargo: { value: 1, label: 'Cargo' },
    cargoRegion: { value: 1, label: 'Cargo region' },
    vesselDwtGroup: { value: 1, label: 'Vessel dwt group' },
    bunkerPlace: { value: 1, label: 'Bunker place' },
};



// WEBPACK FOOTER //
// ./app/components/Hires/common.js